<ngx-spinner [fullScreen]="true" [name]="spinnerName" type="ball-pulse"></ngx-spinner>
<div class="wrapper" *ngIf="!isLoading">
  <div class="desc-c">
    <p class="title">Sorry, the requested page was not found.</p>
    <p class="text-size-18 fw-400 mt-4 text-color-light-2">
      The page you are looking for does not exist, may have been moved, deleted or is temporarily unavailable.
    </p>
  </div>
</div>
